import axios from 'axios';
  
export const  axios_emailgestion_gettypesgestion = async ()=>{
    return  await axios.get(`/emailgestion/gettypesgestion`,{headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}


export const  axios_emailgestion_sendmailgestion = async (datasmessage)=>{
    const headers = {'Accept': 'application/json','Content-Type': "multipart/form-data"}
    return  await axios.post(`/emailgestion/sendmailgestion`, datasmessage,{headers:headers});
}



export const  axios_emailgestion_sendmailvalidationcompagnie = async (datas)=>{
    const headers = {'Accept': 'application/json','Content-Type': "application/json"}
    return  await axios.post(`/emailgestion/sendmailvalidationcompagnie`, datas,{headers:headers});
}


